import { z } from "zod";
import { apiBuilder, prefixApi } from "@zodios/core";
import { datasetFilterSchema, dspDatasetsPaginationSchema, dspSharedMetricFields } from "./common";

const dspInventoryMetricFields = {
  ...dspSharedMetricFields,
  new_to_brand_detail_page_view_rate: z.number().nullable(),
  new_to_brand_detail_page_view_rate_prev: z.number().nullable().optional(),
  new_to_brand_detail_page_view_rate_delta: z.number().nullable().optional(),
  new_to_brand_detail_page_view_rate_percent: z.number().nullable().optional(),

  brand_search_rate: z.number().nullable(),
  brand_search_rate_prev: z.number().nullable().optional(),
  brand_search_rate_delta: z.number().nullable().optional(),
  brand_search_rate_percent: z.number().nullable().optional(),
};

const dspInventoryRowSchema = z.object({
  site: z.string().optional(),
  line_item_id: z.union([z.string(), z.number()]).optional(),
  deal_id: z.union([z.string(), z.number()]).optional(),
  start_date: z.string().optional(),
  ...dspInventoryMetricFields,
});

export type DSPInventoryRow = z.infer<typeof dspInventoryRowSchema>;

const dspInventoryQueryRequestSchema = z.object({
  model: z.literal("dspinventory"),
  dimensions: z.union([z.string(), z.array(z.string())]),
  entity_mode: z.literal("none").optional().default("none"),
  filters: z.array(datasetFilterSchema).optional().default([]),
  sort: z.string().optional(),
  page: z.number().optional(),
  limit: z.number().optional(),
  include_count: z.boolean().optional(),
});

const dspInventoryQueryResponseSchema = z.object({
  data: z.array(dspInventoryRowSchema),
  pagination: dspDatasetsPaginationSchema,
});

export const dspInventoryDatasetsApiDefinitions = prefixApi(
  "/api",
  apiBuilder({
    method: "post",
    path: "/datasets/query/?inventory",
    alias: "dspInventoryDatasetsQuery",
    description: "Query inventory datasets by dimensions + filters",
    parameters: [
      {
        name: "body",
        type: "Body",
        schema: dspInventoryQueryRequestSchema,
      },
    ],
    response: dspInventoryQueryResponseSchema,
  }).build(),
);
